import { Stack, Tabs } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PatientDetailProvider } from 'context/PatientDetailContext';
import { showBloodPressureFeature, showWeightFeature } from 'utils/app';
import { useNavigate, useParams } from 'react-router-dom';
import { useShowRestricted } from 'hooks/useShowRestricted';
import { BloodPressureOverview } from './BloodPressureOverview/BloodPressureOverview';
import { HeartRateOverview } from './HeartRateOverview/HeartRateOverview';
import { WeightBmiOverview } from './WeightBmiOverview/WeightBmiOverview';
import { PatientOverviewTab } from '../../Patients.helpers';

export const Overview = () => {
  const { t } = useTranslation();
  const { patientId, subTab } = useParams<{ patientId: string; subTab?: string }>();
  const { filter } = useShowRestricted();
  const navigate = useNavigate();
  return (
    <PatientDetailProvider>
      <Stack gap={'lg'}>
        <Tabs
          variant={'outline'}
          value={subTab}
          onChange={(tab) => tab && navigate(`/patients/${patientId}/details/overview/${tab}${filter}`)}
          defaultValue={PatientOverviewTab.Heartrate}
        >
          <Tabs.List>
            <Tabs.Tab
              value={PatientOverviewTab.Heartrate}
              data-testid={`tab-patient-data-${PatientOverviewTab.Heartrate}`}
            >
              {t('patients_tab_heartrate')}
            </Tabs.Tab>
            {showBloodPressureFeature && (
              <Tabs.Tab
                value={PatientOverviewTab.Bloodpressure}
                data-testid={`tab-patient-data-${PatientOverviewTab.Bloodpressure}`}
              >
                {t('patients_tab_bloodpressure')}
              </Tabs.Tab>
            )}
            {showWeightFeature && (
              <Tabs.Tab value={PatientOverviewTab.Weight} data-testid={`tab-patient-data-${PatientOverviewTab.Weight}`}>
                {t('patients_tab_weight')}
              </Tabs.Tab>
            )}
          </Tabs.List>
          <Tabs.Panel value={PatientOverviewTab.Heartrate} pt={'xs'}>
            <HeartRateOverview />
          </Tabs.Panel>
          {showBloodPressureFeature && (
            <Tabs.Panel value={PatientOverviewTab.Bloodpressure} pt={'xs'}>
              <BloodPressureOverview />
            </Tabs.Panel>
          )}
          {showWeightFeature && (
            <Tabs.Panel value={PatientOverviewTab.Weight} pt={'xs'}>
              <WeightBmiOverview />
            </Tabs.Panel>
          )}
        </Tabs>
      </Stack>
    </PatientDetailProvider>
  );
};
